var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 67,
    width: 86,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.78 53.153c15.073 14.509 24.437 8.51 48.112-5.238 21.7-10.464 19.682-43.62 1.434-44.551-19.862-1.015-12.276 7.719-30.47 9.87C-9.619 18.495 2.543 40.41 15.78 53.154z",
    fill: "#f4f5f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.015 24.673a6.072 6.072 0 0 0 6.064 6.064 2.695 2.695 0 0 0 2.692-2.691V14.803a2.695 2.695 0 0 0-2.692-2.691h-3.373a2.695 2.695 0 0 0-2.691 2.691zm2.834 0v-9.727h3.087V27.9a3.234 3.234 0 0 1-3.087-3.227zM53.244 28.046a2.695 2.695 0 0 0 2.692 2.691 6.072 6.072 0 0 0 6.065-6.064v-9.87a2.695 2.695 0 0 0-2.692-2.691h-3.373a2.695 2.695 0 0 0-2.692 2.691zm2.835-.146V14.946h3.086v9.727A3.234 3.234 0 0 1 56.08 27.9z",
    fill: "#f7931e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.558 50.143H37.532l3.499-21.133H46z",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.97 49.075h16.15c.433 0 .785.351.785.784v1.12a.785.785 0 0 1-.785.784H34.97a.785.785 0 0 1-.784-.784v-1.12c0-.433.351-.784.785-.784z",
    fill: "#f8a441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.413 51.316h23.265c.277 0 .502.225.502.502v6.084a.502.502 0 0 1-.502.502H31.413a.502.502 0 0 1-.502-.502v-6.084c0-.277.224-.502.502-.502z",
    fill: "#725e4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.045 39.77c-7.113 0-12.933-5.82-12.933-12.933V8.989H55.98v17.848c0 7.113-5.82 12.933-12.934 12.933z",
    fill: "#faae1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.166 5.631h27.758c.76 0 1.376.616 1.376 1.376v2.049c0 .76-.616 1.376-1.376 1.376H29.166c-.76 0-1.376-.616-1.376-1.376V7.007c0-.76.616-1.376 1.376-1.376z",
    fill: "#f7931e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.993 52.504h18.105v4.816H33.993z",
    fill: "#8b7561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.965 26.824h2.827l1.547-7.642h-2.563l.442-2.209c1.634-.265 2.65-.663 3.754-1.325h2.607l-2.253 11.176H47.8l-.574 2.827H38.39z",
    fill: "#ffe082"
  }))));
};
export default SvgTrophy;